import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';
import { ISiteDetailsType } from '@components/SiteLeadOverview';

export const useSiteDetailsQuery = (siteId: string | null): IQueryResponse<ISiteDetailsType> => {
	const fetchSiteDetailsData = async (): Promise<ISiteDetailsType> => {
		return APIService.getData<ISiteDetailsType>(`${APICONFIG.LMS_SITE_ADD_OR_LIST_API}${siteId}/`);
	};

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['SiteDetails', siteId],
		queryFn: fetchSiteDetailsData,
		refetchOnWindowFocus: false,
		retry: false,
		enabled: !!siteId,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
		isFetching,
	};
};
